import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { handleAssociationEntityToPackage } from "./HandleUserActions";
import {
    pushModal,
    pushDialog,
    auditNoteSubmit,
    setDataFileStatusAction,
    saveWorkerAssociationPackageAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    hideFileAction,
    reprocessRepositoryAction,
    requestDataForOrganizationsAction,
    uploadAction,
    downloadAction,
    handleDownloadFilesAction,
    reprocessFileAction,
    sendSalesInformationEmail,
} from "../../store/actions";
import { connect } from "react-redux";
import defaultPackageAssociationStyles from "../../components/SeriesButton/SeriesButton.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const UserActions = (props) => {
    const { params, checkList } = props;
    const [currentCheckedList, setCurrentCheckedList] = useState(undefined);
    const [originalCheckedList, setOriginalCheckedList] = useState(undefined);
    const { pushNotification } = useGlobalValue();

    useEffect(() => {
        if (checkList?.length) {
            const checkedList = (checkList || []).filter((item) => item.checked);
            const stringifiedCheckedList = JSON.stringify(checkedList);
            // Sets the current checked list
            setCurrentCheckedList(stringifiedCheckedList);

            // Set once the original checked list in case there are some checked items in the list
            if (!originalCheckedList) {
                setOriginalCheckedList(stringifiedCheckedList);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(checkList)]);

    // In case of tab changes set both states to original state
    useEffect(() => {
        setCurrentCheckedList(undefined);
        setOriginalCheckedList(undefined);
    }, [params?.entity, params?.filter]);

    // Use effect to run only once
    useEffect(() => {
        if (checkList?.length) {
            const checkedList = (checkList || []).filter((item) => item.checked);
            setOriginalCheckedList(JSON.stringify(checkedList));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (params.section) {
        switch (params.section) {
            case "packages": {
                const changesValidation = {
                    currentCheckedList,
                    originalCheckedList,
                    setCurrentCheckedList,
                    setOriginalCheckedList,
                };
                return packageAssociation({ ...props, pushNotification }, changesValidation);
            }
            default:
                break;
        }
    }

    return null;
};

const packageAssociation = (props, changeValidation) => {
    const { styles, i18n, RegularButton, pushNotification } = props;
    const stylesSelected = { ...defaultPackageAssociationStyles, ...styles };

    const {
        currentCheckedList,
        originalCheckedList,
        setCurrentCheckedList,
        setOriginalCheckedList,
    } = changeValidation;
    const enableSaveButton =
        currentCheckedList && originalCheckedList && currentCheckedList !== originalCheckedList;

    return (
        <div className={stylesSelected["container"]}>
            <RegularButton
                primary
                icon="success"
                onClick={() => {
                    handleAssociationEntityToPackage({
                        ...props,
                        setCurrentCheckedList,
                        setOriginalCheckedList,
                        pushNotification,
                    });
                }}
                className={`${stylesSelected["simple-button"]}`}
                disabled={!enableSaveButton}
            >
                {i18n`save changes`}
            </RegularButton>
        </div>
    );
};

export default connect(
    ({ fetch, menu, uploads }) => ({
        fetch,
        menu,
        uploads,
    }),
    {
        pushModal,
        pushDialog,
        setDataFileStatus: setDataFileStatusAction,
        saveWorkerAssociationPackage: saveWorkerAssociationPackageAction,
        deleteFilePermanently: deleteFilePermanentlyAction,
        deleteInvalidFilePermanently: deleteInvalidFilePermanentlyAction,
        hideFile: hideFileAction,
        downloadFiles: handleDownloadFilesAction,
        reprocessRepository: reprocessRepositoryAction,
        requestDataForOrganizations: requestDataForOrganizationsAction,
        uploadFiles: uploadAction,
        download: downloadAction,
        submitAuditNote: auditNoteSubmit,
        reprocessFiles: reprocessFileAction,
        sendSalesInformationEmail,
    },
)(withRouter(UserActions));
